import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { UploadDialog } from "@/components/UploadDialog";
import { SUBJECTS, materialsWord } from "@/lib/constants";
import { api } from "@/lib/api";

function SubjectCard({ s, count, i }) {
  const Icon = s.icon;
  const big = false;
  return (
    <Link to={`/subject/${s.id}`} data-testid={`subject-card-${s.id}`} style={{ animationDelay: `${i * 40}ms` }}
      className={`rise group relative overflow-hidden rounded-2xl border p-4 sm:p-6 flex flex-col justify-between min-h-[140px] sm:min-h-[170px] transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-lg ${big ? "col-span-2 bg-[#1f5f42] border-[#1f5f42] text-white grain" : "bg-white border-[#d1e7dd]"}`}>
      <div className="flex items-start justify-between">
        <div className={`h-10 w-10 sm:h-12 sm:w-12 rounded-xl grid place-items-center ${big ? "bg-white/10 text-[#a3e6be]" : "bg-[#e8f5ed] text-[#1f5f42]"}`}><Icon className="h-6 w-6" /></div>
        <ArrowUpRight className={`h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${big ? "text-[#a3e6be]" : "text-[#2e7d56]"}`} />
      </div>
      <div className="mt-4 sm:mt-6">
        <div className={`font-display font-bold leading-tight ${big ? "text-xl sm:text-2xl" : "text-base sm:text-lg text-[#0b2e20]"}`}>{s.name}</div>
        <div className={`text-sm mt-1 ${big ? "text-white/70" : "text-[#6b8a7b]"}`} data-testid={`subject-count-${s.id}`}>{materialsWord(count || 0)}</div>
      </div>
    </Link>
  );
}

export default function HomePage() {
  const { user } = useAuth();
  const [counts, setCounts] = useState({});
  useEffect(() => {
    api.get("/materials/counts", { params: { grade: user.grade } }).then((r) => setCounts(r.data)).catch(() => {});
  }, [user.grade]);
  const total = Object.values(counts).reduce((a, b) => a + b, 0);

  return (
    <div>
      <section className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 rise">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2e7d56]" data-testid="home-grade-label">{user.grade} класс · {materialsWord(total)}</p>
          <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold text-[#0b2e20] mt-3 max-w-3xl leading-[1.05]">Материалы для подготовки к СОР и СОЧ</h1>
          <p className="text-[#4b6b5c] mt-4 max-w-xl">Выбери предмет. Загрузи свой файл и получи 50 коинов, когда модератор его одобрит.</p>
        </div>
        <UploadDialog />
      </section>
      <section className="mt-8 sm:mt-12 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-testid="subjects-grid">
        {SUBJECTS.map((s, i) => <SubjectCard key={s.id} s={s} count={counts[s.id]} big={false} i={i} />)}
      </section>
    </div>
  );
}
